import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { PageHeader } from "../components/layout/PageHeader";
import { Card } from "../components/ui/Card";
import { Button } from "../components/ui/Button";
import { fetchArticleById } from "../store/actions/supportActions";
import { ArrowLeft } from "lucide-react";

export default function ArticleDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { article, loading, error } = useSelector((state) => state.support);

  useEffect(() => {
    if (id) dispatch(fetchArticleById(id));
  }, [dispatch, id]);

  return (
    <div className="animate-fadeIn">
      <PageHeader
        title={article ? article.title : "Article"}
        sub={article ? article.category : "Loading..."}
      />
      <Button $variant="ghost" $size="sm" style={{ marginBottom: 16 }} onClick={() => navigate("/support")}>
        <ArrowLeft size={16} style={{ marginRight: 6 }} />
        Back to Support
      </Button>
      {loading && !article && <Card style={{ padding: 24 }}><p style={{ color: "#6b7280" }}>Loading...</p></Card>}
      {error && <Card style={{ padding: 24 }}><p style={{ color: "#dc2626" }}>{error}</p></Card>}
      {article && (
        <Card style={{ padding: 24 }}>
          {article.description && (
            <p style={{ margin: "0 0 16px", fontSize: 16, color: "#6b7280", lineHeight: 1.5 }}>{article.description}</p>
          )}
          <div style={{ fontSize: 15, lineHeight: 1.7, whiteSpace: "pre-wrap" }}>{article.body || "No content."}</div>
        </Card>
      )}
    </div>
  );
}
